/**
 * @file Responsive video
 *
 * Control video presented to user dependent on the window width.
*/

export default class ResponsiveVideo {
    /**
     * Class constructor
     *
     * @arg {object} - `el` Responsive video element
    */
    constructor (el) {
        if (!el) return;
        this.el = el;
        this.breakpoint = 767;

        this.init();

        const mq = window.matchMedia(`(max-width: ${this.breakpoint}px)`);
        mq.addEventListener('change', () => {
            this.init();
        });
    }

    init () {
        const windowWidth = window.innerWidth;
        if (windowWidth > this.breakpoint) {
            if (this.el.dataset.desktopVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.desktopVideo
                );
            }
        } else {
            if (this.el.dataset.mobileVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.mobileVideo
                );
            } else if (this.el.dataset.desktopVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.desktopVideo
                );
            }
        }
    }

    addSourceToVideo (el, src) {
        el.src = src;
    }
}
